import Navbar from './components/Navbar';
import Hero from './components/Hero';
import ProfileSection from './components/ProfileSection';
import TimelineSection from './components/TimelineSection';
import AccountsSection from './components/AccountsSection';
import TrendingSection from './components/TrendingSection';
import GallerySection from './components/GallerySection';
import FaqSection from './components/FaqSection';
import SiteFooter from './components/SiteFooter';

export default function Home() {
  return (
    <>
      <Navbar />
      <main>
        <Hero />
        <ProfileSection />
        <TimelineSection />
        <AccountsSection />
        <TrendingSection />
        <GallerySection />
        <FaqSection />
      </main>
      <SiteFooter />
    </>
  );
}